import styled from 'styled-components';

export const LoadingContainer = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    z-index: 9999;
    background: rgba(0,0,0,.5);
    width: 100%;
    height: 100vh;    
`;